<template>
  <div class="flex justify-items-center items-center">
    <vs-switch
      v-model="innerValue"
      class="mr-3"
    />
    <label :style="style">{{ label }}</label>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DataTableCellSwitch',
  data () {
    return {
      value: null,
      label: null,
      rowIndex: null,
      style: null
    }
  },
  computed: {
    innerValue: {
      get () {
        return this.value
      },
      set (value) {
        this.params.action({
          index: this.rowIndex,
          value
        })
      }
    }
  },
  beforeMount () {
    this.value = this.params.value
    this.label = this.params.value ? '有効' : '無効'
    this.style = this.params.value ? '' : 'color: transparent;'
    this.rowIndex = this.params.rowIndex
  }
})
</script>

<style scoped>

</style>
